<template>
  <article class="gpc-skel" aria-hidden="true">
    <div class="gpc-skel__img gv-skeleton" />
    <div class="gpc-skel__body">
      <div class="gv-skeleton gv-skeleton--line gv-skeleton--line-xs" />
      <div class="gv-skeleton gv-skeleton--line" />
      <div class="gv-skeleton gv-skeleton--line gv-skeleton--line-short" />
      <div class="gpc-skel__footer">
        <div class="gpc-skel__price">
          <div class="gv-skeleton gv-skeleton--line gv-skeleton--price" />
          <div class="gv-skeleton gv-skeleton--line gv-skeleton--mrp" />
        </div>
        <div class="gv-skeleton gv-skeleton--btn-sm" />
      </div>
    </div>
  </article>
</template>

<script>
export default { name: 'GroceryProductCardSkeleton' };
</script>

<style scoped>
.gpc-skel {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #ebe3f5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.gpc-skel__img {
  aspect-ratio: 1;
  border-radius: 0;
}

.gpc-skel__body {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.gpc-skel__footer {
  margin-top: auto;
  padding-top: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}

.gpc-skel__price {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}
</style>
